export const CHANGE_THEME = 'CHANGE_THEME'
export const CHANGE_LANG = 'CHANGE_LANG'
export const STORAGE_DATA = 'STORAGE_DATA'
